import { get } from "../../service/api";

const ExportAdminInvoices = async ({
  startDate,
  endDate,
  merchantId,
  status,
  paymentMethodId,
  callBackResponse,
  userId,
}) => {
  const parts = [
    `startDate=${encodeURIComponent(startDate)}`,
    `endDate=${encodeURIComponent(endDate)}`,
  ];
  if (merchantId) parts.push(`merchantId=${encodeURIComponent(merchantId)}`);
  if (status) parts.push(`status=${encodeURIComponent(status)}`);
  if (paymentMethodId)
    parts.push(`paymentMethodId=${encodeURIComponent(paymentMethodId)}`);
  if (callBackResponse)
    parts.push(`callBackResponse=${encodeURIComponent(callBackResponse)}`);
  if (userId) parts.push(`userId=${encodeURIComponent(userId)}`);
  return get(`/invoice/export?${parts.join("&")}`);
};

export default ExportAdminInvoices;
